<template>
  <article class="view">
    <header class="view__header" v-if="header">
      <VText center>{{ header }}</VText>

      <router-link class="view__back"
        v-if="backButtonTo"
        :to="backButtonTo"
      />
    </header>

    <main class="view__content">
      <slot />
    </main>
  </article>
</template>

<script>
export default {
  name: 'VView',

  props: {
    backButtonTo: {
      type: String,
    },

    header: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  &__header {
    position: relative;

    padding: $gridGutter;
  }

  &__back {
    position: absolute;

    top: 0;
    left: $gridGutter;
    width: 50px;
    height: 100%;



    background-image: url('~@/assets/icon-back.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;

    &:hover {
      background-image: url('~@/assets/icon-back-hover.png');
    }
  }

  &__content {
    padding: $gridGutter;
  }
}
</style>
